import * as types from 'actions/purchases/types';

const statusShape = {
  isOnLazyLoad: false,
  isLoading: false,
  data: [],
  page: 0,
  isAllItemsWereLoaded: false,
  error: null,
};

//Оставила структуру, как у Страниц с табками, т.к. могут появиться купленные EPG события
const initialState = {
  vod: { ...statusShape },
};

export default (state = initialState, action) => {
  switch (action.type) {
    case types.FETCH: {
      const { type } = action.payload;
      state[type] = { ...state[type], isLoading: true };
      return { ...state };
    }
    case types.FETCH_SUCCESS: {
      const { type, content } = action.payload;
      state[type] = { ...state[type], isLoading: false, data: content };
      return { ...state };
    }
    case types.FETCH_ERROR: {
      const { type, error } = action.payload;
      state[type] = { ...state[type], isLoading: false, error };
      return { ...state };
    }
    case types.LOAD_EXTRA_ITEMS: {
      const { type } = action.payload;
      state[type] = { ...state[type], isOnLazyLoad: true };
      return { ...state };
    }
    case types.LOAD_EXTRA_ITEMS_SUCCESS: {
      const { type, content, page } = action.payload;
      const data = state[type].data.concat(content);
      state[type] = { ...state[type], isOnLazyLoad: false, data, page };
      return { ...state };
    }
    case types.LOAD_EXTRA_ITEMS_COMPLETED: {
      const { type } = action.payload;
      state[type] = { ...state[type], isAllItemsWereLoaded: true, isOnLazyLoad: false };
      return { ...state };
    }
    case types.LOAD_EXTRA_ITEMS_ERROR: {
      const { type, error } = action.payload;
      state[type] = { ...state[type], error };
      return { ...state };
    }
    case types.RESET_ALL_DATA:
      return { ...initialState };
    default:
      return state;
  }
};
